module.exports = __webpack_public_path__ + "static/media/maintainence.49c76a42.jpg";